import { XIcon } from 'lucide-react';
import { useState } from 'react';

export default function PromotionalBanner() {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  if (!isBannerVisible) {
    return <></>;
  }

  return (
    <div className="bg-[#168566] text-sm p-1 text-white flex items-center justify-between">
      <p className="px-4 flex-1 lg:text-center">
        Not happy with the logo that&apos;s generated? Try re-generating it.
      </p>
      <button
        onClick={() => {
          setIsBannerVisible(false);
        }}
        className="px-2"
      >
        <XIcon size={18} />
      </button>
    </div>
  );
}
